import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IDeleteProjektArtResponse, IProjektArt } from 'fa-kt.types';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ActionService, ISitemap, ISitemapCommand, ISitemapModel, SITEMAP } from 'pbc.angular';
import { BehaviorSubject, Subscription } from 'rxjs';
import { DeleteProjektArtCommandService } from '../service';

interface IFormValue {
  projektArt?: IProjektArt;
}

@Component({
  selector: 'fa-kt-delete-projekt-art',
  templateUrl: './delete-projekt-art.component.html',
  styleUrls: ['./delete-projekt-art.component.css'],
})
export class DeleteProjektArtCommandComponent implements OnInit, OnDestroy {
  command!: ISitemapCommand;
  model!: ISitemapModel;

  subscriptions: Subscription[] = [];
  form!: FormGroup;
  $loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $valid: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  @Input() set loading(loading: boolean) {
    this.$loading.next(this.$loading.getValue() || loading);
  }
  @Input() set value(value: IFormValue) {
    this.patch(value);
  }
  @Output() valid: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() finished: EventEmitter<IDeleteProjektArtResponse> = new EventEmitter<IDeleteProjektArtResponse>();

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    private fb: FormBuilder,
    private actions: ActionService,
    private message: NzMessageService,
    public deleteProjektArt: DeleteProjektArtCommandService,
  ) {
    this.command = sitemap.PROJEKTE.Commands.DELETE_PROJEKT_ART;
    this.model = sitemap.PROJEKTE.Models.PROJEKT_ART;
    /* << constructor    */
    /*    constructor >> */
    this.form = this.fb.group({
      id: [null, [Validators.required]],
    });
    this.patch();
  }

  ngOnInit() {
    this.subscriptions.push(
      this.$valid.subscribe((valid: boolean) => {
        this.valid.emit(valid);
        if (valid) {
          this.actions.subscribe({ key: this.command.translation, action: async () => await this.submit() });
        } else {
          this.actions.unsubscribe(this.command.translation);
        }
      }),
    );
  }

  ngOnDestroy() {
    this.actions.unsubscribe(this.command.translation);
    this.subscriptions.filter(($: Subscription) => $ && !$.closed).forEach(($: Subscription) => $.unsubscribe());
  }

  private patch(value?: IFormValue) {
    if (value && value.projektArt && value.projektArt.id) {
      this.form.controls.id.patchValue(value.projektArt.id);
    } else {
      this.form.controls.id.patchValue(null);
    }
    this.update();
  }

  update() {
    this.$loading.next(true);
    this.form.markAsDirty();
    this.form.updateValueAndValidity();
    this.$valid.next(this.form.valid);
    this.$loading.next(false);
  }

  async submit() {
    this.update();
    if (!this.form.valid) {
      return;
    }
    this.$loading.next(true);
    try {
      const response: IDeleteProjektArtResponse = await this.deleteProjektArt.request(this.form.value);
      this.finished.next(response);
    } catch (error: any) {
      this.message.error(error.message);
    }
    this.$loading.next(false);
  }
}
